// React
import { PropsWithChildren } from "react"

export function BaseTable(params: PropsWithChildren<{
  className?: string
  plain?: boolean
}>): JSX.Element {
  return <table className={`table ${!params.plain && "table-bordered table-zebra"} ${params.className}`}>{params.children}</table>
}